<template>
  <div>
    <hooper ref="carousel" :settings="hooperSettings" @slide="updateSlide">
      <slide v-for="(tutorial, index) in tutorials" :key="index">
        <h2 v-if="tutorial.title" class="pl-4 text-white">{{ tutorial.title }}</h2>
        <div class="video-cover text-center" v-if="!tutorial.showVideo" :style="{ backgroundImage: `url('${tutorial.coverImageUrl}')` }">
          <i class="fa fa-play-circle" @click="showVideo(tutorial)"></i>
        </div>
        <video v-else class="mb-4" width="100%" height="240" autoplay controls>
          <source :src="tutorial.videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="pl-4">
          <p class="mt-4">{{ tutorial.description }}</p>
        </div>
      </slide>
    </hooper>
    <div v-if="tutorialCount > 1" class="row p-4">
      <div class="col-12 text-center pb-3">
        <i v-for="(tutorial, key) in tutorials"
           @click="goToSlide(key)"
           v-bind:key="key"
           :class="(key === slideNumber ? 'fas' : 'far') + ' fa-circle pl-1 pr-1'">
        </i>
      </div>
      <div class="col-6">
        <button :disabled="slideNumber === 0" @click.prevent="slidePrev" class="btn btn-outline-light">PREV</button>
      </div>
      <div class="col-6 text-right">
        <button :disabled="slideNumber + 1 === tutorialCount" @click.prevent="slideNext" class="btn btn-outline-light">NEXT</button>
      </div>
    </div>
  </div>
</template>
<script>
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'
export default {
  name: 'tutorial',
  components: { Hooper, Slide },
  props: [
    'tutorials'
  ],
  data () {
    return {
      hooperSettings: {
        infiniteScroll: false
      },
      slideNumber: 0
    }
  },
  methods: {
    slideNext (slide) {
      this.$refs.carousel.slideNext()
    },
    slidePrev (slide) {
      this.$refs.carousel.slidePrev()
    },
    goToSlide (slide) {
      this.slideNumber = slide
    },
    updateSlide (slide) {
      this.slideNumber = slide.currentSlide
    },
    showVideo (tutorial) {
      this.$set(tutorial, 'showVideo', true)
    }
  },
  watch: {
    slideNumber () {
      this.$refs.carousel.slideTo(this.slideNumber)
    }
  },
  computed: {
    tutorialCount () {
      return this.tutorials.length
    }
  }
}
</script>

<style>
  .video-cover {
    min-height: 300px;
    width: 100%;
    background: no-repeat;
    background-size: 100%;
    font-size: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video-cover i {
    cursor: pointer;
  }
  .hooper {
    height: 100%;
  }
  .hooper:focus {
    outline: none;
  }
  .hooper p {
    font-size: 18px;
  }
</style>
